import { FC } from "react"
import { PrivacyPolicy } from "../../../module/systems/containers/privacyPolicy"

export const PrivacyPolicyPage: FC = () => <PrivacyPolicy />
